<template>
  <span class="sr-only">
    <span v-if="colors.length === 1">
      Finns i färgen {{ colors[0].ColorName }},
    </span>
    <span v-else-if="colors.length > 1">
      Finns i färgerna
      {{ colors.map((color) => color.ColorName).join(', ') }},
    </span>
  </span>
</template>

<script lang="ts" setup>
import type { ColorDto } from '~/models/ListingProduct.api.model';

interface Props {
  colors?: ColorDto[];
}

withDefaults(defineProps<Props>(), {
  colors: () => [],
});
</script>
